import authHelpers from "@/utils/auth-helpers";
import axios from "@axios";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";

export default {
  namespaced: true,
  state: {
    loading: false,
    sending: false,
  },
  getters: {
    loading(state) {
      return state.loading;
    },
    sending(state) {
      return state.sending;
    },
  },
  mutations: {
    setLoading(state, val) {
      state.loading = val;
    },
    setSending(state, val) {
      state.sending = val;
    },
  },
  actions: {
    fetchEmails({ commit }, payload) {
      var pre = authHelpers.isUserMinistry() ? "/ministry" : "";
      commit("setLoading", true);
      return new Promise((resolve, reject) => {
        axios
          .get("v2" + pre + "/messages", {
            params: payload,
          })
          .then((response) => resolve(response))
          .catch((error) => reject(error))
          .finally(() => {
            commit("setLoading", false);
          });
      });
    },
    fetchEmailById({ commit }, id) {
      var pre = authHelpers.isUserMinistry() ? "/ministry" : "";
      commit("setLoading", true);
      return new Promise((resolve, reject) => {
        axios
          .get("v2" + pre + "/messages/" + id)
          .then((response) => resolve(response))
          .catch((error) => reject(error))
          .finally(() => {
            commit("setLoading", false);
          });
      });
    },
    sendEmail({ commit, dispatch }, payload) {
      commit("setSending", true);
      var pre = authHelpers.isUserMinistry() ? "/ministry" : "";

      return new Promise((resolve, reject) => {
        axios
          .post("v2" + pre + "/messages/send", payload)
          .then((response) => {
            dispatch("handleResponse", response);
            resolve(response);
          })
          .catch((error) => reject(error))
          .finally(() => {
            commit("setSending", false);
          });
      });
    },
    sendReply({ commit, dispatch }, payload) {
      commit("setSending", true);
      var pre = authHelpers.isUserMinistry() ? "/ministry" : "";

      return new Promise((resolve, reject) => {
        axios
          .post("v2" + pre + "/messages/reply", payload)
          .then((response) => {
            dispatch("handleResponse", response);
            resolve(response);
          })
          .catch((error) => reject(error))
          .finally(() => {
            commit("setSending", false);
          });
      });
    },
    updateEmailLabels(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .post("/apps/email/update-emails-label", payload)
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    paginateEmail(ctx, payload) {
      return new Promise((resolve, reject) => {
        axios
          .get("/apps/email/paginate-email", { params: payload })
          .then((response) => resolve(response))
          .catch((error) => reject(error));
      });
    },
    handleResponse(_, res) {
      if (res.status > 399 && res.status <= 500) {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "حدث خطأ أثناء إرسال الرسالة",
            icon: "AlertCircleIcon",
            variant: "danger",
          },
        });
        return false;
      } else {
        this._vm.$toast({
          component: ToastificationContent,
          props: {
            title: "تم إرسال الرسالة بنجاح",
            icon: "CheckSquareIcon",
            variant: "success",
          },
        });
        return true;
      }
    },
  },
};
